import { render, staticRenderFns } from "./CommDialog.vue?vue&type=template&id=64101d5b&scoped=true"
import script from "./CommDialog.vue?vue&type=script&lang=js"
export * from "./CommDialog.vue?vue&type=script&lang=js"
import style0 from "./CommDialog.vue?vue&type=style&index=0&id=64101d5b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64101d5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64101d5b')) {
      api.createRecord('64101d5b', component.options)
    } else {
      api.reload('64101d5b', component.options)
    }
    module.hot.accept("./CommDialog.vue?vue&type=template&id=64101d5b&scoped=true", function () {
      api.rerender('64101d5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/CommDialog.vue"
export default component.exports